import { cloneElement, ReactElement } from "react";
import { Tooltip, TooltipProps } from "@mui/material";
import { useOverflow } from "../hooks";
import styles from "./index.module.css";

export type OverflowTooltipProps = {
	children: ReactElement;
} & Omit<TooltipProps, "children" | "title">;

export function OverflowTooltip({ children }: OverflowTooltipProps) {
	const [textRef, isOverflowed] = useOverflow();
	const title = <div className={styles.titleContent}>{children}</div>;
	const childWithRef = cloneElement(children, {
		ref: textRef,
		className: `${children.props.className ?? ""} ${styles.tooltipContent}`.trim(),
	});

	if (!isOverflowed) return childWithRef;
	return <Tooltip title={title}>{childWithRef}</Tooltip>;
}
